<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <zestawieniaMenu></zestawieniaMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Zestawienia nieobecności w firmie</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row ">
            <div class="col-auto d-flex align-items-center me-3">
              <select v-model="selectedDepartament" class="form-select form-sm mb-2" style="width: 360px;" @change="loadAllDataForUsers">
                <option value="0">WSZYSTKIE DZIAŁY</option>
                <option v-for="(department, depId) in departaments" :key="depId" :value="department.id">{{ department.name }}</option>
				<option value="-1">POZOSTALI PRACOWNICY</option>
              </select>
            </div>
			<div class="col-auto d-flex align-items-center me-3">
			<select v-model="selectedMonth" class="form-select form-sm mb-2" style="width: 140px;" @change="loadAllDataForUsers">
			  <option value="0">Cały rok</option>
			  <option v-for="(name, index) in months" :key="index" :value="index + 1">{{ name }}</option>
			</select>
			</div>
            <div class="col-auto d-flex align-items-center me-3">
              <select v-model="selectedYear" class="form-select form-sm mb-2" style="width: 140px;" @change="loadAllDataForUsers">
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
            <div class="col-auto d-flex align-items-center">
              <input type="text" v-model="searchQuery" placeholder="Szukaj pracownika..." class="form-control form-sm mb-3" style="width: 220px;"/>
            </div>
			 <div class="col-auto d-flex align-items-center me-3 mb-2">
				<a 
				  :href="route('kadry.zestawienia.wolne.pdf', { 
					departament: selectedDepartament, 
					rok: selectedYear,
					miesiac: selectedMonth
				  })" 
				  target="_blank" 
				  class="btn btn-info me-2"
				>
				  <i class="bi bi-file-earmark-pdf"></i>
				  &nbsp;Pobierz zestawienie w PDF
				</a>
				<a 
				  :href="route('kadry.zestawienia.wolne.xlsx', { 
					departament: selectedDepartament, 
					rok: selectedYear,
					miesiac: selectedMonth
				  })" 
				  target="_blank" 
				  class="btn btn-success me-2"
				>
				  <i class="bi bi-file-earmark-excel"></i>
				  &nbsp;Pobierz zestawienie w XLSX
				</a>			  </div>
			
          </div>
          <div class="table-responsive w-100">
            <table class="table table-bordered table-hover text-center">
              <thead>
                <tr>
                  <th class="bg-gray-100 text-start" @click="sortBy('userName')" style="cursor:pointer">
                    Pracownik
                    <span v-if="sortKey === 'userName'"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
				  <th class="bg-gray-100 text-start" @click="sortBy('tenrok')" style="cursor:pointer">
				    Urlop ten rok
				    <span v-if="sortKey === 'tenrok'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
				  </th>
				  <th class="bg-gray-100 text-start" @click="sortBy('poprzednirok')" style="cursor:pointer">
				    Urlop poprzedni rok
				    <span v-if="sortKey === 'poprzednirok'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
				  </th>
				  <th class="bg-gray-100 text-start" @click="sortBy('pozostalo')" style="cursor:pointer">
				    Urlop pozostało
				    <span v-if="sortKey === 'pozostalo'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
				  </th>
                  <th v-for="typ in typyUrlopowGrouped" :key="typ.skrot" class="bg-gray-100" @click="sortBy(typ.skrot)" style="cursor:pointer">
                    {{ typ.skrot }}
                    <span v-if="sortKey === typ.skrot"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                </tr>
              </thead>
			  <tbody>
			    <tr v-for="user in filteredAndSortedUsers" :key="user.userId">
				  <td class="text-start">{{ user.userName }}</td>
				  <td class="text-start">{{ user.tenRok }}</td>
				  <td class="text-start">{{ user.poprzedniRok }}</td>
				  <td class="fw-bold bg-light">{{ getRemainingVacation(user) }}</td>
				  <td v-for="typ in typyUrlopowGrouped" :key="typ.skrot">{{ Object.keys(groupMap) .filter(s => groupMap[s] === typ.skrot) .reduce((sum, s) => sum + (user.dniUrlopow?.[s] ?? 0), 0) }}</td>
			    </tr>
			  </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import zestawieniaMenu from "@/Pages/Kadry/parts/zestawieniaMenu.vue";
import axios from 'axios';

export default {
  components: { AppLayout, zestawieniaMenu },
  props: {
    departaments: Array,
    departamentId: Number,
  },
  data() {
    const today = new Date();
    return {
      users: [],
      typyUrlopow: [],
      selectedYear: today.getFullYear(),
      years: Array.from({ length: 6 }, (_, i) => today.getFullYear() - 5 + i),
      selectedDepartament: this.departamentId ?? 1,
      selectedMonth: 0,
	   months: [
      'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
      'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
    ],
      searchQuery: "",
      sortKey: "userName",
      sortOrder: "desc",
    };
  },
computed: {
  groupMap() {
    return {
      // Urlopy
      Uw: "Urlopy", UWW: "Urlopy", Uż: "Urlopy", Uok: "Urlopy", Ub: "Urlopy", Um: "Urlopy",
      Ut: "Urlopy", Ur: "Urlopy", W: "Urlopy", Wd: "Urlopy",

      // Chorobowe
      Ch: "Chorobowe", Cho: "Chorobowe", Śrh: "Chorobowe",

      // Opieka
      Uo: "Opieka",

      // Siła wyższa
      Sw: "Siła wyższa",

      // Nauka
      Sz: "Nauka", Us: "Nauka",

      // Wyjazdy (S + typy z id=100 -> backend już wysyła, skrót np. 'S100')
      S: "Wyjazdy", S100: "Wyjazdy",
      
	  // krew
	  Np: "Krwiodawstwo",
	 
	  // inna nieobecność
	  Nn: "Inna nieobecność", N: "Inna nieobecność",

	  // Home office
	  HO: "Home Office",

	  Uoj: "Urlop ojcowski",

    };
  },

  typyUrlopowGrouped() {
    const groups = {};
    this.typyUrlopow.forEach((t) => {
      const group = this.groupMap[t.skrot] || t.skrot; 
      groups[group] = true;
    });

    const order = ["Urlopy", "Urlop ojcowski", "Chorobowe", "Opieka", "Siła wyższa", "Nauka", "Wyjazdy", "Krwiodawstwo", "Inna nieobecność", "Home Office"];
    return order.filter((g) => groups[g]).map((g) => ({ skrot: g, nazwa: g }));
  },


  filteredAndSortedUsers() {
    let result = this.users;

    // filtr
    if (this.searchQuery) {
      const q = this.searchQuery.toLowerCase();
      result = result.filter((u) => u.userName.toLowerCase().includes(q));
    }

    // sortowanie
    return result.slice().sort((a, b) => {
      let aVal, bVal;

if (this.sortKey === "userName") {

  aVal = a.userName.toLowerCase();
  bVal = b.userName.toLowerCase();

} else if (this.sortKey === "pozostalo") {

  aVal =
    Number(a.razemDniUrlop || 0) -
    Number(a.dniUrlopow?.Uw || 0);

  bVal =
    Number(b.razemDniUrlop || 0) -
    Number(b.dniUrlopow?.Uw || 0);

}
else if (this.sortKey === "tenrok") {

  aVal =
    Number(a.tenRok || 0) -
    Number(a.dniUrlopow?.Uw || 0);

  bVal =
    Number(b.tenRok || 0) -
    Number(b.dniUrlopow?.Uw || 0);

}
else if (this.sortKey === "poprzednirok") {

  aVal =
    Number(a.poprzedniRok || 0) -
    Number(a.dniUrlopow?.Uw || 0);

  bVal =
    Number(b.poprzedniRok || 0) -
    Number(b.dniUrlopow?.Uw || 0);

}
 else {

  const skróty = Object.keys(this.groupMap).filter(
    (s) => this.groupMap[s] === this.sortKey
  );

  aVal = skróty.reduce(
    (sum, s) => sum + (a.dniUrlopow?.[s] ?? 0),
    0
  );

  bVal = skróty.reduce(
    (sum, s) => sum + (b.dniUrlopow?.[s] ?? 0),
    0
  );

}

      if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  },
},
  methods: {
  getRemainingVacation(user) {
  return (
    Number(user.razemDniUrlop || 0) -
    Number(user.dniUrlopow?.Uw || 0)
  );
},

    async loadAllDataForUsers() {
      try {
        const response = await axios.get(
          route("kadry.zestawienia.wolne.getallinfo"),
          {
            params: {
              departament: this.selectedDepartament,
              rok: this.selectedYear,
			  miesiac: this.selectedMonth,
            },
          }
        );

        this.typyUrlopow = response.data.typyUrlopow ?? [];
        this.users = response.data.users.map((u) => {
          return {
            userId: u.userId,
            userName: u.userName,
            dniUrlopow: u.dniUrlopow ?? {},
            tenRok: u.tenRok ?? 0,
            poprzedniRok: u.poprzedniRok ?? 0,
            razemDniUrlop: u.razemDniUrlop ?? 0,
          };
        });
      } catch (error) {
        console.error("Błąd ładowania danych:", error);
      }
    },

    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
  },
  mounted() {
    this.loadAllDataForUsers();
  },
};
</script>

<style scoped>
table th,
table td {
  min-width: 50px;
  height: 32px;
  text-align: center;
}
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}
</style>
